import { Box, Flex, Grid, Input } from '@chakra-ui/react';
import { AppLink, CloseIcon, Image, LANDING_ROUTES, pxToRem, SearchIcon } from '@cyberkongz/ui';
import { ExtractedPostWithAssets } from '@features/blog/apiContentful';
import { useMemo, useState } from 'react';

export function BlogSearch({ posts }: { posts: ExtractedPostWithAssets[] }) {
  const [searchInput, setSearchInput] = useState('');
  const [isOpened, setIsOpened] = useState(false);

  const searchedPosts = useMemo(
    () =>
      posts.filter(
        ({ title, excerpt }) =>
          title.toLowerCase().includes(searchInput.toLowerCase()) ||
          excerpt.toLowerCase().includes(searchInput.toLowerCase())
      ),
    [searchInput]
  );

  return (
    <Box color="textSecondary">
      {isOpened ? (
        <Box position="relative">
          <Flex css={{ position: 'relative' }}>
            <SearchIcon
              css={{
                position: 'absolute',
                zIndex: 1,
                top: '50%',
                transform: 'translateY(-50%)',
                left: 3,
                width: pxToRem(18),
                height: pxToRem(18),
              }}
            />
            <Input
              onChange={(e) => setSearchInput(e.target.value)}
              value={searchInput}
              placeholder="Search"
              css={{
                px: 10,
                bg: 'transparent',
                border: 'none',
                borderRadius: 'none',
                borderBottom: 'thin',
                borderBottomColor: 'neutral.400',
              }}
            />
            <CloseIcon
              onClick={() => {
                setSearchInput('');
                setIsOpened(false);
              }}
              css={{
                cursor: 'pointer',
                position: 'absolute',
                top: '50%',
                right: 3,
                transform: 'translateY(-50%)',
                width: pxToRem(22),
              }}
            />
          </Flex>
          {searchInput !== '' ? (
            <Grid
              gap={3}
              css={{
                position: 'absolute',
                right: 0,
                w: pxToRem(400),
                mt: 3,
                bg: 'backgroundSecondary',
                zIndex: 2,
                p: 3,
                overflow: 'auto',
                maxHeight: '70vh',
              }}
            >
              {searchedPosts.length > 0
                ? searchedPosts.map(({ title, thumbnail, slug }) => (
                    <AppLink href={LANDING_ROUTES.BLOG_POST(slug)} key={slug}>
                      <Flex gap={2} fontSize="sm">
                        <Image
                          css={{ maxWidth: pxToRem(150) }}
                          src={thumbnail?.fields.file?.url}
                          alt={thumbnail?.fields.title}
                        />
                        {title}
                      </Flex>
                    </AppLink>
                  ))
                : `Couldn't find any posts`}
            </Grid>
          ) : null}
        </Box>
      ) : (
        <Box
          onClick={() => setIsOpened(true)}
          css={{
            cursor: 'pointer',
          }}
        >
          <SearchIcon width={pxToRem(18)} height={pxToRem(18)} />
        </Box>
      )}
    </Box>
  );
}
